import { normalizeReturnToPath } from './return-path';

/** A public slug is a route hint, never a tenant identifier or permission. */
export function publicOrganizationReturn(value: string | null | undefined): { readonly slug: string; readonly path: string } | undefined {
  const safe = normalizeReturnToPath(value);
  if (!safe) return undefined;
  const parsed = new URL(safe, 'https://event.invalid');
  const match = /^\/o\/([a-z0-9][a-z0-9-]{0,62})\/?$/.exec(parsed.pathname);
  return match ? { slug: match[1]!, path: safe } : undefined;
}

export function publicOrganizationEntryPath(publicPath: string): string | undefined {
  const target = publicOrganizationReturn(publicPath);
  if (!target) return undefined;
  const parsed = new URL(target.path, 'https://event.invalid');
  parsed.searchParams.set('enter', '1');
  return `${parsed.pathname}${parsed.search}`;
}
